// 项目全局配置
const config = {
  // 项目名称（登录页、菜单栏同步显示）
  appName: '房检云',

  // 是否开启验证码
  captcha: true,

  // Mock 配置（开发/测试环境使用）
  mock: {
    enabled: false,       // true = 请求走 mock，false = 走真实接口
    delay: 200           // 模拟响应延迟(ms)，0 = 立即响应
  }
}

export default config
